/* eslint-disable react/jsx-props-no-spreading */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading } from 'components/chroma';
import { SCREEN } from 'scenes/common/types/screen';

import { isCarCampaign } from 'scenes/motor/helpers/campaign';

import { MarketingCampaignCardProps } from '../types';
import MarketingCampaignBannerContent from './MarketingCampaignBannerContent';

const CampaignImage = styled.img`
  height: 52px;
  width: 52px;
  margin-right: 0.5em;
`;

const CardContainer = styled.div`
  display: block;
`;

const InnerContainer = styled.div`
  display: flex;
  align-items: center;

  .c-btn--link {
    color: ${THEME.LINK.ACCESSIBLE} !important;
  }
`;

const MainContainer = styled.div`
  padding: 1.5em 2em 1em 2em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${THEME.BACKGROUND.CARD};
  flex-flow: wrap;
  margin-top: 1em;
  margin-bottom: 1em;
  border: 1px solid ${THEME.FIELD.BORDER.DEFAULT};
  @media (min-width: ${SCREEN.LARGE}px) {
    border: none;
  }
`;

export const MarketingCampaignCard: FunctionComponent<
  MarketingCampaignCardProps & {
    quoteNumber: string;
  }
> = ({
  termsLinkText,
  quoteNumber,
  headerText,
  imageUrl,
  setIsModalOpen,
  campaign,
}) => (
  <MainContainer>
    <CardContainer>
      {Boolean(quoteNumber) && <Heading size={5}>Offer applied</Heading>}
      <InnerContainer>
        <CampaignImage
          src={imageUrl}
          tabIndex={-1}
          alt="Campaign graphic"
          aria-hidden
        />
        <div>
          <MarketingCampaignBannerContent
            text={headerText}
            onClick={setIsModalOpen}
            exclusions={isCarCampaign(campaign?.id ?? '')}
            termsLinkText={termsLinkText}
          />
        </div>
      </InnerContainer>
    </CardContainer>
  </MainContainer>
);

export default MarketingCampaignCard;
